import { KeyboardEvent, RefObject, useCallback } from 'react'

import { KEY_VALUES } from '../constants'

type KeyboardHandler = (event: KeyboardEvent<HTMLElement>) => void

interface UseToggleKeyDownEventParams {
  toggle: boolean
  active: boolean
  targetRef: RefObject<HTMLElement>
  overlayRef: RefObject<HTMLElement>
  searchInputRef: RefObject<HTMLInputElement>
  openMenu: () => void
  closeMenu: () => void
  onTargetBackspace: KeyboardHandler
  onMenuKeyDown: KeyboardHandler
  onMenuPressEnter: KeyboardHandler
  onMenuPressBackspace: KeyboardHandler
}

const SEARCHABLE_KEY_PATTERN = /\w/

export const useToggleKeyDownEvent = ({
  toggle,
  active,
  targetRef,
  overlayRef,
  searchInputRef,
  openMenu,
  closeMenu,
  onTargetBackspace,
  onMenuKeyDown,
  onMenuPressEnter,
  onMenuPressBackspace,
}: UseToggleKeyDownEventParams) =>
  useCallback(
    (event: KeyboardEvent<HTMLElement>) => {
      if (event.target === targetRef.current) {
        if (toggle && event.key === KEY_VALUES.ENTER) {
          if (active) {
            closeMenu()
          } else {
            openMenu()
          }
        }

        if (event.key === KEY_VALUES.BACKSPACE) {
          onTargetBackspace(event)
        }
      }

      if (event.key === KEY_VALUES.ESC || event.key === KEY_VALUES.TAB) {
        closeMenu()
      }

      if (overlayRef.current) {
        onMenuKeyDown(event)

        if (event.key === KEY_VALUES.ENTER) {
          onMenuPressEnter(event)
        }
        if (event.key === KEY_VALUES.BACKSPACE) {
          onMenuPressBackspace(event)
        }
        if (event.key.length === 1 && SEARCHABLE_KEY_PATTERN.test(event.key)) {
          searchInputRef.current?.focus()
        }
      }
    },
    [
      toggle,
      active,
      targetRef,
      overlayRef,
      searchInputRef,
      openMenu,
      closeMenu,
      onTargetBackspace,
      onMenuKeyDown,
      onMenuPressEnter,
      onMenuPressBackspace,
    ],
  )
